import React from 'react'
import './style.css'

export const Details = () => {
    return (
        <div className='Details'>
            {/* <DetailsElement /> */}
            <div className='Title'>
                Детали
            </div>
            <div className='Details__subtitle'>Цветы</div>
            <div className='Details__text'>
                Пожалуйста, не дарите нам цветы, мы не успеем насладиться их красотой. Но если вы желаете сделать нам комплимент, то будем признательны, если вы добавите эту сумму в нашу копилку
            </div>
            <div className='Details__subtitle'>Съемка</div>
            <div className='Details__text'>
                На нашей свадьбе будет прекрасный фотограф, НО не будет видеографа. Поэтому съемка на телефоны разрешена и даже приветствуется :))
            </div>
        </div>
    )
}
